import React from 'react';

import { ReactComponent as Icon } from '../../../../assets/icons/filter.svg';

export default function FilterIcon(props: any) {
    return <Icon {...props} />;
}
